import http from "../common/api";
import { ApiSettings } from "application";

const getManagerByBillIssuer = async (name) => {
  return await http.get(ApiSettings.loadManagerByBillIssuer + name, {});
};

export default getManagerByBillIssuer;
